(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ant-design/icons-vue"), require("axios"), require("makeit-tooltip"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@ant-design/icons-vue", "axios", "makeit-tooltip", "vue"], factory);
	else if(typeof exports === 'object')
		exports["captcha"] = factory(require("@ant-design/icons-vue"), require("axios"), require("makeit-tooltip"), require("vue"));
	else
		root["captcha"] = factory(root["@AntDesign/IconsVue"], root["Axios"], root["MakeitTooltip"], root["Vue"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__305__, __WEBPACK_EXTERNAL_MODULE__687__, __WEBPACK_EXTERNAL_MODULE__895__) {
return 